import { useTranslation } from 'react-i18next'
import { Reveal, Etiqueta } from '../../brand'

type Role = { role: string; stake: string; question: string; answer: string }

/** A sala de decisão: cinco papéis, cinco perguntas, cinco provas (PRODUCT.md do modelo — comprador que responde pela máquina). */
export function Committee() {
  const { t } = useTranslation()
  const roles = t('model.committee.roles', { returnObjects: true }) as Role[]
  return (
    <Reveal as="div" stagger={0.08} y={14} className="z-committee">
      {roles.map((r) => (
        <div key={r.role} className="z-committee__linha">
          <div><p className="z-committee__papel">{r.role}</p><Etiqueta as="p">{r.stake}</Etiqueta></div>
          <div><p className="z-committee__pergunta">“{r.question}”</p><p className="z-committee__resposta">{r.answer}</p></div>
        </div>
      ))}
    </Reveal>
  )
}

type Value = { name: string; body: string; give: string }

/** Valores com renúncia declarada (Sobre). */
export function ValuesGrid() {
  const { t } = useTranslation()
  const items = t('model.about.values.items', { returnObjects: true }) as Value[]
  return (
    <Reveal as="div" stagger={0.08} y={14} className="z-values">
      {items.map((v) => (
        <div key={v.name} className="z-value" data-anatomy="campo"><p className="z-value__nome">{v.name}</p><p className="z-value__corpo">{v.body}</p><p className="z-value__renuncia">{v.give}</p></div>
      ))}
    </Reveal>
  )
}

/** Propósito · Visão · Missão em três colunas. */
export function PurposeTriad() {
  const { t } = useTranslation()
  return (
    <Reveal as="div" stagger={0.1} y={14} className="z-tres">
      {(['purpose', 'vision', 'mission'] as const).map((k) => (
        <div key={k}><p className="z-tres__titulo">{t(`model.about.${k}.title`)}</p><p className="z-tres__corpo">{t(`model.about.${k}.body`)}</p></div>
      ))}
    </Reveal>
  )
}
